<template>
  <!-- TODO: 自定义工单筛选器 -->
  <div id='bd-aside'>
    <el-row>
      <el-col :span="10">
        <el-menu class="el-menu-vertical-demo"
          default-active="1"
          :default-openeds="defaultOpened"
          @select="handleSelect"
          @open="handleOpen"
          @close="handleClose">
          <el-menu-item index="0">
            <span slot="title">{{ $t('createTicket') }}</span>
          </el-menu-item>
          <el-submenu index="1">
            <template slot="title">
              <span>{{ $t('mineTickets') }}</span>
            </template>
            <el-menu-item index="1-1">
              <el-badge v-if="forMeReplyTicketsUnreadCount > 0" :value="forMeReplyTicketsUnreadCount">{{ $t('forMeToReply') }}</el-badge>
              <span v-if="forMeReplyTicketsUnreadCount === 0">{{ $t('forMeToReply') }}</span>
            </el-menu-item>
            <!-- <el-menu-item index="1-3">我创建的</el-menu-item> -->
            <el-menu-item index="1-5">
              <el-badge v-if="toBeRepliedTicketsUnreadCount > 0" :value="toBeRepliedTicketsUnreadCount">{{ $t('tobeReplied') }}</el-badge>
              <span v-if="toBeRepliedTicketsUnreadCount === 0">{{ $t('tobeReplied') }}</span>
            </el-menu-item>
          </el-submenu>
          <!-- <el-submenu index="2">
            <template slot="title">
              <span>技能组工单</span>
            </template>
            <el-menu-item index="2-1">待认领</el-menu-item>
          </el-submenu> -->
           <el-submenu index="3">
            <template slot="title">
              <span>{{ $t('finishedTicket') }}</span>
            </template>
            <el-menu-item index="3-1">
              <el-badge v-if="doneTicketsUnreadCount > 0" :value="doneTicketsUnreadCount">{{ $t('finished') }}</el-badge>
              <span v-if="doneTicketsUnreadCount === 0">{{ $t('finished') }}</span>
            </el-menu-item>
            <el-menu-item index="3-2">
              <el-badge v-if="ignoreTicketsUnreadCount > 0" :value="ignoreTicketsUnreadCount">{{ $t('ignored') }}</el-badge>
              <span v-if="ignoreTicketsUnreadCount === 0">{{ $t('ignored') }}</span>
            </el-menu-item>
            <el-menu-item index="3-3">
              <el-badge v-if="closedTicketsUnreadCount > 0" :value="closedTicketsUnreadCount">{{ $t('visitorClose') }}</el-badge>
              <span v-if="closedTicketsUnreadCount === 0">{{ $t('visitorClose') }}</span>
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </el-col>
      <el-col :span="14">
        <div class="online-search">
          <span style="font-size: 10px;">{{ ticketTip }}</span>
          <!-- <el-input style="width: 90%;" size="mini" :placeholder="searchTip" suffix-icon="el-icon-search" v-model="search" clearable></el-input> -->
          <!-- <el-button style="float: right;" size="mini" icon="el-icon-refresh" circle @click="refreshData()"></el-button> -->
        </div>
        <div v-if="showLoading" class="pullrefresh">
          <i class="el-icon-loading"/><span>{{ this.$t('loadingData') }}</span>
        </div>
        <div style="height: calc(100% - 60px); overflow-y: auto;">
          <li v-for="ticket in filterdTickets.content" :key="ticket.tid" class="list-item"
            :class="{ ' active': ticket.tid === userCurrentTicket.tid && ticket.thread.tid === userCurrentThread.tid }"
            @click.exact="selectTicket(ticket)"
            @click.right="rightEvent(ticket)"
            @contextmenu.prevent="onContextmenu">
            <div class="list-right">
              <div class="top">
                <span class="nickname">
                  {{ ticket.title }}
                  <el-badge v-if="ticket.thread.unreadCount > 0" :value="ticket.thread.unreadCount"></el-badge>
                </span>
                <span class="timestamp">
                  {{ ticket.createdAt | time }}
                </span>
              </div>
              <div class="bottom">
                <el-tag v-if="!ticket.urgent" size="mini">{{ $t('normal') }}</el-tag>
                <el-tag v-if="ticket.urgent" type="danger" size="mini">{{ $t('urgent') }}</el-tag>
                <el-tag type="warning" size="mini">{{ ticket.category.name }}</el-tag>
                <!-- <span v-html="ticket.content"></span> -->
              </div>
            </div>
          </li>
          <el-empty v-if="filterdTickets.content.length === 0" description="暂无工单"></el-empty>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
// import * as https from '@/apis/http'
import bus from '@/util/eventbus'
import { mapActions, mapGetters } from 'vuex'
const constants = require('@/util/constants')

export default {
  name: 'bd-aside',
  data () {
    return {
      showLoading: false,
      search: '',
      defaultOpened: [
        '1', '3'
      ],
      showType: 1, // 1,2,3,4
      page: 0,
      size: 20
    }
  },
  computed: {
    ...mapGetters([
      'userCurrentTicket',
      'userCurrentThread',
      'userTickets',
      'userForMeReplyTickets',
      'userToBeRepliedTickets',
      'userDoneTickets',
      'userIgnoredTickets',
      'userClosedTickets',
      'forMeReplyTicketsUnreadCount',
      'toBeRepliedTicketsUnreadCount',
      'doneTicketsUnreadCount',
      'ignoreTicketsUnreadCount',
      'closedTicketsUnreadCount'
    ]),
    searchTip () {
      return this.$t('search')
    },
    ticketTip() {
      if (this.showType === 1) {
        return this.$t('forMeToReply')
      } else if (this.showType === 2) {
        return this.$t('tobeReplied')
      } else if (this.showType === 3) {
        return this.$t('finished')
      } else if (this.showType === 4) {
        return this.$t('ignored')
      } else if (this.showType === 5) {
        return this.$t('visitorClose')
      }
      return this.$t('forMeToReply')
    },
    filterdTickets () {
      // return this.userTickets.filter(ticket => {
      //   return ticket.title.includes(this.search) || ticket.content.includes(this.search)
      // })
      if (this.showType === 1) {
        return this.userForMeReplyTickets
      } else if (this.showType === 2) {
        return this.userToBeRepliedTickets
      } else if (this.showType === 3) {
        return this.userDoneTickets
      } else if (this.showType === 4) {
        return this.userIgnoredTickets
      } else if (this.showType === 5) {
        return this.userClosedTickets
      }
      return {
        content: [],
        page: 0, // 当前页面
        first: true, //
        last: true, // 是否还有更多聊天记录
        totalElements: 0
      }
    }
  },
  methods: {
    ...mapActions([ 'updateCurrentTicket', 'getTicketForMeReply',
      'getTicketTobeReplied', 'getTicketCreatedByMe', 'getTicketProcessingByMe',
      'getTicketUnclaim', 'getTicketDone', 'getTicketIgnore', 'getTicketClosed' ]),
    showStatus (status) {
      if (status === 'unclaim') {
        return '待认领'
      } else if (status === 'to_be_replied') {
        return '待我回复'
      } else if (status === 'processing') {
        return '处理中'
      } else if (status === 'done') {
        return '已解决'
      } else if (status === 'ignore') {
        return '已忽略'
      }
      return status
    },
    selectTicket (ticket) {
      // console.log('selectTicket:', ticket)
      // TODO: 对于工单，仅加载此工单聊天记录
      this.updateCurrentTicket(ticket)
    },
    rightEvent (ticket) {
      console.log('rightTicket:', ticket)
    },
    // 引用第三方组件: https://github.com/GitHub-Laziji/menujs
    onContextmenu (event) {
      console.log('context menu')
    },
    handleSelect (key, keyPath) {
      // console.log('key:', key, ' path:', keyPath)
      if (key === '0') {
        // console.log('create')
        bus.$emit(constants.EVENT_BUS_SHOW_TICKET_DRAWER)
      } else if (key === '1-1') {
        // 待我回复
        this.getForMeReply()
      }
      // else if (key === '1-3') {
      //   // 我创建的
      //   this.getCreatedByMe()
      // }
      else if (key === '1-5') {
        // 等待回复
        this.getTobeReplied()
      }
      // else if (key === '2-1') {
      //   // 待分配的
      //   this.getUnclaim()
      // }
      else if (key === '3-1') {
        // 已解决
        this.getDone()
      } else if (key === '3-2') {
        // 已忽略
        this.getIgnored()
      } else if (key === '3-3') {
        // 访客关闭
        this.getClosed()
      }
    },
    handleSuccessCallback(response) {
      // console.log('success:', response)
      this.showLoading = false
    },
    handleFailedCallback(error) {
      // console.log('error:', error)
      this.showLoading = false
    },
    getForMeReply() {
      // 
      this.showLoading = true
      this.showType = 1
      let payload = { page: this.page, size: this.size, successcb: this.handleSuccessCallback, failedcb: this.handleFailedCallback }
      this.getTicketForMeReply(payload)
    },
    getTobeReplied() {
      //
      this.showLoading = true
      this.showType = 2
      let payload = { page: 0, size: 20, successcb: this.handleSuccessCallback, failedcb: this.handleFailedCallback }
      this.getTicketTobeReplied(payload)
    },
    getDone () {
      //
      this.showLoading = true
      this.showType = 3
      let payload = { page: 0, size: 20, successcb: this.handleSuccessCallback, failedcb: this.handleFailedCallback }
      this.getTicketDone(payload)
    },
    getIgnored () {
      //
      this.showLoading = true
      this.showType = 4
      let payload = { page: 0, size: 20, successcb: this.handleSuccessCallback, failedcb: this.handleFailedCallback }
      this.getTicketIgnore(payload)
    },
    getClosed() {
      //
      this.showLoading = true
      this.showType = 5
      let payload = { page: 0, size: 20, successcb: this.handleSuccessCallback, failedcb: this.handleFailedCallback }
      this.getTicketClosed(payload)
    },
    refreshData () {
      // console.log('refreshData')
    },
    handleOpen (key, keyPath) {
      // console.log(key, keyPath)
    },
    handleClose (key, keyPath) {
      // console.log(key, keyPath)
    },
    // getToBeReplied () {
    //   // 待回复
    //   this.getTicketTobeReplied(payload)
    // },
    // getCreatedByMe () {
    //   let payload = { page: 0, size: 20 }
    //   this.getTicketCreatedByMe(payload)
    // },
    // getProcessingByMe () {
    //   let payload = { page: 0, size: 20 }
    //   this.getTicketProcessingByMe(payload)
    // },
    // getUnclaim () {
    //   let payload = { page: 0, size: 20 }
    //   this.getTicketUnclaim(payload)
    // },
  },
  mounted() {
    //
    this.getForMeReply()
  },
  filters: {
    // 将日期过滤为 hour:minutes
    time (value) {
      if (typeof value === 'string') {
        return moment(value).format('MM-DD HH:mm')
      } else {
        return value
      }
    }
  }

}
</script>

<style scoped>
.pullrefresh {
  margin-top: 20px;
  text-align: center;
  font-size: 10px;
  color: blue;
  cursor: pointer;
}
#bd-side {
 height: 100%;
 width: 100%;
 overflow: hidden;
}
.el-menu-vertical-demo {
  height: 100%;
  overflow-y: auto;
}
/* .el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
} */
/* FIXME: 不起作用？ */
.el-submenu__title {
  padding-left: 0px !important;
}
.el-submenu .el-menu-item {
  width: 90px !important;
  padding-left: 0px !important;
}
.el-col {
  height: 100%;
}
.online-search {
  padding: 12px 12px 12px 12px;
}
.list-item {
  padding: 5px 5px 5px 5px;
  margin-bottom: 0px;
  border-bottom: 1px solid beige;
  height: 50px;
}
.list-item:hover {
  background-color: rgb(220,220,220)
}
.active {
  background-color:darkkhaki
}
.list-item .avatar {
  border-radius: 2px;
  margin-right: 2px;
}
li {
  list-style: none;
}
.list-left {
  margin-top: 4px;
  margin-left: 2px;
  width: 25px;
  height: 25px;
  float: left;
}
#bd-aside .list-right {
  margin-left: 5px;
}
.list-right {
  margin-left: 12px;
}
.list-right .top {
  margin-top: 2px;
  text-align: left;
}
span.nickname {
  display: inline-block;
  vertical-align: top;
  font-size: 14px;
  width: calc(100% - 10px);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
span.timestamp {
  float: right;
  color:gray;
  font-size: 12px;
  vertical-align: top;
  width: 68px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.list-right .bottom {
  width: 0%;
  text-align: left;
}
.list-right .bottom-queue {
  width: 90%;
  text-align: left;
}
.list-right .bottom .content{
  font-size: 12px;
  width: 150px;
  height: 100%;
  color: gray;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.list-right .unreadCount {
    margin-top: 4px;
    float: right;
    font-size: 10px;
    width: 12px;
    height: 12px;
    line-height: 12px;
    text-align: center;
    border-radius:5px;
    color: white;
    background-color: red;
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
</style>
